<template>
  <div>
    <div v-for="(product, product_index) in product_detail" :key="`${_uid}:promo:${product_index}`">
      <section v-if="parse_servizi(product.baseProdotto.pid).length" class="section promo">
        <h2 class="vb-heading mb-4">Promo e proposte</h2>
        <vb-tabs
          :vb_options="{vertical: !is_mobile()}"
          :set_parsed_services="parsed_service = parse_servizi(product.baseProdotto.pid)"
        >
          <b-tab
              v-for="(service_product, service_product_index) in parsed_service"
              :key="_uid+service_product_index"
              :title="service_product.titolo_servizio !== '' && service_product.titolo_servizio | lowercase"
          >
            <p class="h5">{{ service_product.titolo_servizio | uppercase }}</p>
            <span v-if="service_product.descrizione_servizio !== ''" v-html="service_product.descrizione_servizio.replaceAll('•', '<br>')"></span>
          </b-tab>
        </vb-tabs>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'promo',
  props: {
    statics_detail: Object,
    product_detail: Array,
  },
  data() {
    return {
      black_terms : ['altre opportunità', 'promo proposte', 'programmi combinati', 'vantaggi']
    }
  },
  methods: {
    // senza titolo il servizio non ha etichetta per il tab: sui tour è la scheda
    // riassuntiva (durata, km, guida...) già resa da panoramic-tour
    parse_servizi(pid) {
      return this.statics_detail[pid].schedaProdotto.servizi_prodotto.filter(({ titolo_servizio = '' }) => {
        const title = titolo_servizio.trim().toLowerCase()
        return title !== '' && !this.black_terms.includes(title)
      })
    }
  }
}
</script>

<style lang="scss">

  .promo {
    @extend %section_margin;

    @include media-breakpoint-up(md) {
      padding-top: $grid-gutter-20*3;
    }

    &.section {
      margin-bottom: $grid-gutter-20;
    }

    ul:last-child {
      margin-bottom: 0;
    }
  }

</style>